import { Add } from '@/icons'
import type { IAvailableApps } from '@/utils/availableApps'
import { } from '@chakra-ui/react'
import { MenuItem } from './MenuItem'
import { NewInsuranceButtonCarkulka } from './NewInsuranceButtonCarkulka'
import { NewInsuranceButtonChaloupka } from './NewInsuranceButtonChaloupka'

export const NewInsuranceButton = ({ app }: { app: IAvailableApps['appId'] }) => {
  if (app === 'carkulka') {
    return <NewInsuranceButtonCarkulka app={app} />
  }

  if (app === 'chaloupka') {
    return <NewInsuranceButtonChaloupka />
  }

  return (
    <MenuItem variant="solid" colorScheme="primary" to={`/${app}/wizard/1?new`}>
      <Add />
      Nové pojištění
    </MenuItem>
  )
}